export const TIPOS_EMPRESA = [
  { id: 'MEI', descricao: 'MEI - Microempreendedor Individual' },
  { id: 'EI', descricao: 'EI - Empresário Individual' },
  { id: 'EIRELI', descricao: 'EIRELI - Empresa Individual de Responsabilidade Limitada' },
  { id: 'SLU', descricao: 'SLU - Sociedade Limitada Unipessoal' },
  { id: 'LTDA', descricao: 'LTDA - Sociedade Limitada' },
  { id: 'SA', descricao: 'SA - Sociedade Anônima' },
  { id: 'SS', descricao: 'SS - Sociedade Simples' }
]
